import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AuthUser from "../../../Hooks/authUser";
import Loading from "../../../Shared/Loading";
import AdminAllDoctorsTable from "./AdminAllDoctorsTable";

const AdminDashboardDoctors = () => {
  const [loading, setLoading] = useState(false);
  const { userInfo } = AuthUser();
  const [searchInput, setSearchInput] = useState("");
  const [selected, setSelected] = useState("");
  const [filterData, setFilterData] = useState([]);
  const [doctors, setDoctors] = useState([]);

  const fetchDoctors = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://servercareseebd.careseebd.com/api/v1/user/specific?fieldName=role&&fieldValue=doctor&&fieldName2=referralId&&fieldValue2=${userInfo?._id}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("careSeeAccessToken")}`,
          },
        }
      );
      const data = await response.json();
      setDoctors(data?.data || []);
      setFilterData(data?.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching doctors:", error);
    }
  };

  useEffect(() => {
    fetchDoctors();
  }, []);

  const filter = doctors?.filter((user) => {
    const activity = user?.isActive ? "active" : "inActive";
    return (
      (!searchInput || user?.name?.toLowerCase()?.includes(searchInput?.toLowerCase())) &&
      (!selected || selected === "all" || activity === selected)
    );
  });

  useEffect(() => {
    setFilterData(filter);
  }, [searchInput, selected, doctors]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Table Card Directory */}
      <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm space-y-6">
        {/* Header Action Row */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-base font-extrabold text-slate-800 tracking-tight flex items-center gap-2">
              <Icon icon="solar:users-group-two-rounded-bold-duotone" className="text-secondary text-xl" />
              <span>Doctors Directory</span>
            </h1>
            <p className="text-xs text-slate-400 font-semibold mt-0.5">Manage doctor user profiles, active statuses, package costs, and clinic patients.</p>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            {/* Status Dropdown */}
            <div className="relative">
              <select
                onChange={(e) => setSelected(e.target.value)}
                className="appearance-none bg-slate-50 border border-slate-200 text-xs font-bold text-slate-600 pl-3 pr-8 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-secondary cursor-pointer"
                name="patientType"
              >
                <option value="all">All Doctors</option>
                <option value="active">Active Doctors</option>
                <option value="inActive">Inactive Doctors</option>
              </select>
              <Icon icon="solar:alt-arrow-down-linear" className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 text-sm pointer-events-none" />
            </div>

            {/* Search Input */}
            <div className="relative min-w-[200px]">
              <Icon icon="solar:magnifer-linear" className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm" />
              <input
                onChange={(e) => setSearchInput(e.target.value)}
                className="w-full bg-slate-50 border border-slate-200 text-xs font-semibold text-slate-700 pl-9 pr-4 py-2 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-secondary transition placeholder:text-slate-400"
                type="search"
                name="search"
                placeholder="Search by name..."
              />
            </div>

            <Link
              to="/adminDashboard/overview"
              className="bg-secondary hover:bg-secondary/95 text-white font-bold py-2 px-4 rounded-xl shadow-md shadow-indigo-900/10 hover:shadow-lg transition duration-200 hover:-translate-y-0.5 active:translate-y-0 text-xs flex items-center gap-1.5 cursor-pointer"
            >
              <Icon className="text-base" icon="solar:user-plus-bold" />
              <span>Add Doctor</span>
            </Link>
          </div>
        </div>

        {/* Doctors Table */}
        <div className="overflow-x-auto rounded-xl border border-slate-100">
          <table className="w-full text-left border-collapse" cellSpacing="0">
            <thead>
              <tr className="bg-slate-50/75 border-b border-slate-100">
                <th scope="col" className="h-12 px-6 text-[10px] font-bold uppercase tracking-wider text-slate-450">
                  Name
                </th>
                <th scope="col" className="h-12 px-6 text-[10px] font-bold uppercase tracking-wider text-slate-450">
                  Email
                </th>
                <th scope="col" className="h-12 px-6 text-[10px] font-bold uppercase tracking-wider text-slate-450">
                  Role
                </th>
                <th scope="col" className="h-12 px-6 text-[10px] font-bold uppercase tracking-wider text-slate-450">
                  Status
                </th>
                <th scope="col" className="h-12 px-6 text-[10px] font-bold uppercase tracking-wider text-slate-450 text-right">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50 font-medium">
              {filterData.length > 0 ? (
                filterData.map((doctor) => (
                  <AdminAllDoctorsTable key={doctor._id} doctor={doctor} onUpdate={fetchDoctors} />
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="h-32 text-center text-xs text-slate-400 font-semibold bg-slate-50/20">
                    No doctor accounts found matching criteria.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardDoctors;
